import React from "react";
import { Link } from "react-router-dom";
const ServerErrorPage = () => {
  return (
    <>
      <div className="content">
        <div className="container">
          <div
            className="error-main-logo text-center"
            style={{
              display: "flex",
              justifyContent: "center",
            }}
          >
            <img src="assets/img/logo-dark.svg" alt="Img" />
          </div>
          <div className="error-img text-center">
            <img src="assets/img/error-500.svg" alt="Img" />
          </div>
          <div className="maintenance-update">
            <div className="text-center mb-3">
              <h5 className="mb-1">500 - Oops! Đã xảy ra lỗi trên máy chủ</h5>
              <p className="text-gray-6">
                Chúng tôi đang gặp sự cố kết nối với máy chủ. Vui lòng thử lại
                sau hoặc quay lại trang chủ.
              </p>
            </div>
            <div className="d-flex align-items-center justify-content-center">
              <Link
                to="/"
                className="btn btn-primary d-flex align-items-center justify-content-center"
              >
                <i className="isax isax-arrow-left-2 me-2"></i>Trang chủ
              </Link>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ServerErrorPage;
